module.exports = __webpack_public_path__ + "fonts/trust_sans_regular_it-webfont.b402884f.woff";